import { OverlayTrigger, Tooltip } from "react-bootstrap"
import { ReactElement } from "react"
import type { OverlayInjectedProps } from "react-bootstrap/esm/Overlay"

interface ButtonWithTooltipProps {
  text: string
  children: ReactElement
  delay?: number
}

const ButtonWithTooltip = ({ text, children, delay = 0 }: ButtonWithTooltipProps) => {
  const renderTooltip = (props: OverlayInjectedProps) => (
    <Tooltip {...props}>{text}</Tooltip>
  )

  return (
    <OverlayTrigger
      placement="top"
      overlay={renderTooltip}
      delay={{ show: delay, hide: 0 }}
    >
      {children}
    </OverlayTrigger>
  )
}

export default ButtonWithTooltip